export default "__VITE_ASSET__BfDM8L8z__"